import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrderDataKeyPipe } from '../../pipes/order-data-key.pipe';
import { OrderDataFieldPipe } from '../../pipes/order-data-field.pipe';
import { OrderDataValuePipe } from '../../pipes/order-data-value.pipe';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, lastValueFrom, Subscription } from 'rxjs';
import { Scan } from 'src/app/models/scan.model';
import { User } from 'src/app/models/user.model';
import { ClinicService } from 'src/app/services/clinic.service';
import { FormResponseService } from 'src/app/services/form-response.service';
import { ScanService } from 'src/app/services/scan.service';
import { Analysis, DeviceStatus, Patient, SensingtexService } from 'src/app/services/sensingtex.service';
import { ServicesService } from 'src/app/services/services.service';
import { UserService } from 'src/app/services/user.service';
import { invertFootData } from '../analysis-details/pressureMapHelpers';
import Swal from 'sweetalert2';
import { FormResponse, InsolesPrescriptionResponse } from 'src/app/models/formResponse.model';
import { insoleComponentesConfig } from '../insole-component/components-config';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { AnalysisDetailsReportPdfComponent } from '../analysis-details-report-pdf/analysis-details-report-pdf.component';
import { AnalysisDetailsComponent } from '../analysis-details/analysis-details.component';
import { PressureMapComponent } from '../pressure-map/pressure-map.component';
import { InsolesPrescriptionComponent } from '../insoles-prescription/insoles-prescription.component';
import { AnalysisComponent } from '../analysis/analysis.component';
import { ModalProFeaturesComponent } from '../modal-pro-features/modal-pro-features.component';
import { MatDialog } from '@angular/material/dialog';
import { FilesComponent } from '../files/files.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { InsolesPrescriptionMapper } from '../insoles-prescription/insoles-prescription-mapper';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { PdfServicesService } from 'src/app/services/pdf-services.service';
import { HttpClient } from '@angular/common/http';
import JSZip from 'jszip';
import { OrderPdfGeneratorService } from 'src/app/services/order-pdf-generator.service';
import { OrderPdfMapper } from 'src/app/utils/order-pdf.mapper';

export interface Topcards {
  id: number;
  img: string;
  color: string;
  title: string;
  subtitle: string;
  orderFilter?: string;
  click?: (statusId: string) => void
}

declare const AdobeDC: any;
declare global {
  interface Window {
    AdobeDC: any;
  }
}

@Component({
  selector: 'app-order-details',
  standalone: true,
  imports: [SharedModule, AnalysisDetailsReportPdfComponent, AnalysisDetailsComponent, PressureMapComponent, InsolesPrescriptionComponent, AnalysisComponent, ModalProFeaturesComponent, FilesComponent, OrderDataKeyPipe, OrderDataFieldPipe, OrderDataValuePipe],
  templateUrl: './order-details.component.html',
  styleUrl: './order-details.component.scss'
})
export class OrderDetailsComponent implements OnInit {
  @ViewChild('imageDialog') imageDialog!: TemplateRef<any>;
  public user: User;
  orderId: string;
  order: Scan = null;
  videoUrl: string = null
  orderRecord: any;
  private orderRecordSubscription: Subscription;
  formResponse: any = null;
  questionIcons = {
    inputText: { icon: 'text_fields', color: '#369bfb' },
    longText: { icon: 'description', color: '#69b5fc' },
    email: { icon: 'email', color: '#98cdfc' },
    dropdown: { icon: 'arrow_drop_down_circle', color: '#d65c99' },
    uniqueChoice: { icon: 'radio_button_checked', color: '#de7faf' },
    multipleChoice: { icon: 'check_box', color: '#d55b98' },
    customComponents: { icon: 'view_module', color: '#fa9e31' },
    productsList: { icon: 'inventory_2', color: '#adebe4' },
    insolesPrescription: { icon: 'healing', color: '#adebe4' },
    requiredImages: { icon: 'photo-scan', color: '#c0adebff' }
  }
  patients: Patient[] = []
  patientAnalyses: Analysis[] = []
  selectedPatient: Patient
  visible: boolean = false
  staticModalVisible: boolean = false
  dynamicModalVisible: boolean = false
  balanceModalVisible: boolean = false
  upgradeModalVisible: boolean = false
  showEditPatientDataModal: boolean = false
  isLoading: boolean = false
  PDFDetailsVisible: boolean = false
  userServices: any = []
  premiumUser: boolean = false
  connectedPlatform: boolean = false
  clientName: string | null = null
  editableFields: { key: string, value: any }[] = [];
  editForm!: FormGroup;
  selectedOrder: Scan = null
  currentKey: string = '';
  videoSafeUrl!: SafeResourceUrl;

  // When the formResponse contains insoles prescription it will be true
  hasInsolesPrescription: boolean = false;
  hasOrderForm: boolean = false
  hasCustomComponents: boolean = false
  insolesPrescriptionForm: FormGroup

  topcards: Topcards[] = []
  displayedColumns: string[] = ['type', 'chargedTo', 'createdAt'];
  showGeneralTab: boolean = true
  showPressurePlateTab: boolean = false
  showPrescriptionTab: boolean = false
  showChargesTab: boolean = false
  showFilesTab: boolean = false

  constructor(
    private route: ActivatedRoute,
    private orderService: ScanService,
    private formResponseService: FormResponseService,
    private formBuilder: FormBuilder,
    private sensingtexService: SensingtexService,
    private userService: UserService,
    private router: Router,
    private servicesService: ServicesService,
    private clinicService: ClinicService,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private scanService: ScanService,
    private pdfServicesService: PdfServicesService,
    private http: HttpClient,
    private translate: TranslateService,
    private orderPdfGenerator: OrderPdfGeneratorService
  ) {
    this.user = userService.user

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.scrollToTop();
    });

    const navigation = this.router.getCurrentNavigation()
    const state = navigation?.extras.state as { clientName?: string }
    this.clientName = state?.clientName ?? null
  }

  ngOnInit(): void {
    this.orderId = this.route.snapshot.paramMap.get("orderId")
    this.loadRequiredData()
    this.getRecordById();
    this.checkServices()
  }

  ngOnDestroy() {
    if (this.insolesPrescriptionForm) {
      this.insolesPrescriptionForm.reset();
    }

    if (this.orderRecordSubscription) {
      this.orderRecordSubscription.unsubscribe();
    }
  }

  enablePremium() {
    this.premiumUser = true
  }

  checkServices() {
    this.servicesService.getServices().subscribe((services) => {
      this.userServices = services;
      this.premiumUser = this.userServices.some(service => service.name === 'Pro features' && service.active);
    })
  }

  setTopCards() {
    this.topcards = [
      {
        id: 1,
        color: 'success',
        img: '/assets/images/svgs/billetera.png',
        title: this.translate.instant('OD_PAID_FILES'),
        subtitle: this.order.accountedFiles ? this.order.accountedFiles.toString() : '0',
      },
      {
        id: 2,
        color: 'warning',
        img: '/assets/images/svgs/error.png',
        title: this.translate.instant('OD_NOT_PAID_FILES'),
        subtitle: this.order.notAccountedFiles ? this.order.notAccountedFiles.toString() : '0',
      },
      {
        id: 3,
        color: 'accent',
        img: '/assets/images/svgs/images.png',
        title: this.translate.instant('OD_IMAGES_CARD'),
        subtitle: this.order.imageFilesAccount ? this.order.imageFilesAccount.toString() : '0',
      },
      {
        id: 4,
        color: 'error',
        img: '/assets/images/svgs/pdf.png',
        title: this.translate.instant('OD_PDFS_CARD'),
        subtitle: this.order.pdfFilesAccount ? this.order.pdfFilesAccount.toString() : '0',
      },
    ];
  }

  loadRequiredData() {
    this.orderService.getOne(this.orderId).subscribe((scan) => {
      this.order = scan;

      if (this.order.formResponseId) {
        this.getFormResponseById();
      }

      this.order.accountedFiles = 0;
      this.order.notAccountedFiles = 0;
      this.order.imageFilesAccount = 0;
      this.order.pdfFilesAccount = 0;
      this.order.dynamicPressureFilesAccount = 0;
      this.order.staticPressureFilesAccount = 0;
      this.order.videoFilesAccount = 0;

      if (this.order.files) {
        this.order.files.map((file) => {
          if (file.type === 'stl' || file.type === 'obj') {
            if (file.user === 'System Processor') {
              if (file.paid)
                this.order.accountedFiles++;
              else {
                this.order.notAccountedFiles++;
              }
            }
          } else if (file.type === 'jpeg' || file.type === 'png') {
            this.order.imageFilesAccount++;
          }
          else if (file.type === 'pdf') {
            this.order.pdfFilesAccount++;
          } else if (file.type === 'json') {
            if (file.name.includes("static")) {
              this.order.staticPressureFilesAccount++;
            }
            else if (file.name.includes("dynamic") || file.name.includes("balance")) {
              this.order.dynamicPressureFilesAccount++;
            }
          } else if (file.type === 'mp4') {
            this.order.videoFilesAccount++
            this.videoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(file.path);
          }

        })
      } else {
        this.order.files = []
      }

      this.setTopCards()
      this.loadPatients()
    })

    // if (this.UserService.user.role === 'ROLE_DISTRIBUTOR_PROFESSIONAL') {
    //     if (localStorage.getItem('extensions')) {
    //         let extensions: [string] = JSON.parse(localStorage.getItem('extensions'));
    //         scan.files = scan.files.filter((file) => extensions.find((extension) => extension === file.type ? true : false))
    //     }
    // }
  }

  loadPatients() {
    this.isLoading = true

    this.sensingtexService.getPatients(this.user.sensingtexManagerId).subscribe((patients) => {
      this.patients = patients;

      const matchingPatient = patients.find(patient => patient.id === this.order?.sensingtexPatientId);

      if (matchingPatient) {
        this.selectedPatient = matchingPatient;
        this.loadPatientAnalysis(matchingPatient.id)
      } else {
        this.selectedPatient = null;
      }

    });

    this.isLoading = false
  }

  loadPatientAnalysis(patientId: string) {
    this.sensingtexService.getAllAnalysesByPatientId(patientId, this.user.sensingtexManagerId, this.user.sensingtexHardwareId).subscribe(patientAnalyses => {
      this.patientAnalyses = patientAnalyses.map(patientAnalyses => {

        if (patientAnalyses.type === "Dynamic") {
          patientAnalyses.additionalParameters[12]["activePointsLeft"] = invertFootData(patientAnalyses.additionalParameters[12]["activePointsLeft"], { x: false, y: false });
          patientAnalyses.additionalParameters[13]["activePointsRight"] = invertFootData(patientAnalyses.additionalParameters[13]["activePointsRight"], { x: true, y: true });
        }

        return {
          ...patientAnalyses,
          creationDate: this.formatCreationDate(patientAnalyses.creationDate)
        }
      })
      this.isLoading = false
    })
  }

  startAnalysis() {
    this.visible = true;

    this.sensingtexService.getUserDevices(this.user.sensingtexManagerId).subscribe({
      next: (userDevices) => {
        const userDeviceId = userDevices[0]._id.$oid

        this.sensingtexService.getDeviceStatus(userDeviceId).subscribe({
          next: (userDeviceStatus: DeviceStatus) => {
            console.log("userDeviceStatus: ", userDeviceStatus)
            if (userDeviceStatus.deviceFunctional) {
              this.connectedPlatform = true
            } else {
              this.connectedPlatform = false
            }
          },
          error: (err) => {
            console.error("Error al obtener el estado de la plataforma: ", err)
          }
        })
      },
      error: (err) => {
        console.error("Error al obtener los user devices: ", err)
      }
    })

    if (this.order.sensingtexPatientId) {
      this.sensingtexService.selectPatientToDoAnalysis(this.selectedPatient, this.user.sensingtexManagerId).subscribe(
        () => {
          console.log("Paciente seleccionado para realizar análisis");
        },
        (error) => {
          console.error("Error al seleccionar paciente para realizar análisis:", error);
        }
      );
    } else {
      const name = this.order.data["Patient Data"].name;
      let weight = this.order.data["Patient Data"].weight;
      let height = this.order.data["Patient Data"].height;

      if (!weight || weight === 0) {
        weight = 70;
      }

      if (!height || height === 0) {
        height = 170;
      }

      this.sensingtexService.createPatient({ name, weight, height }, this.user.sensingtexManagerId).subscribe(
        (response) => {
          console.log("Paciente creado con éxito:", response);

          const newPatientId = response.id;

          this.orderService.updateSensingtexPatientId(this.orderId, newPatientId).subscribe(
            () => {
              console.log("order.sensingtexPatientId actualizado con éxito");
            },
            (error) => {
              console.error("Error al actualizar order.sensingtexPatientId:", error);
            }
          );

          const newPatient = {
            id: newPatientId,
            isSelected: false,
            managerId: this.user.sensingtexManagerId,
            name: name,
            weight: weight,
            height: height
          }

          this.sensingtexService.selectPatientToDoAnalysis(newPatient, this.user.sensingtexManagerId).subscribe(
            () => {
              this.selectedPatient = newPatient
              console.log("Paciente seleccionado para realizar análisis");
            },
            (error) => {
              console.error("Error al seleccionar paciente para realizar análisis:", error);
            }
          );
        },
        (error) => {
          console.error("Error al crear paciente:", error);
        }
      );
    }
  }

  requestAnalysis(analysisType) {

    const staticTimerSeconds = 3
    const dynamicTimerSeconds = 20
    const balanceTimerSeconds = 15

    this.visible = false

    if (analysisType === "static") {
      this.staticModalVisible = false

      this.sensingtexService.requestAnalysis(this.selectedPatient, analysisType, this.user.sensingtexHardwareSerial, this.user.sensingtexManagerId).subscribe()
      Swal.fire({
        title: this.translate.instant('OD_DOING_ANALYSIS'),
        html: this.translate.instant('OD_STAND_3_SEC'),
        timer: staticTimerSeconds * 1000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          this.loadPatients()
        }
      })
    }

    if (analysisType === "dynamic") {
      this.dynamicModalVisible = false

      this.sensingtexService.requestAnalysis(this.selectedPatient, analysisType, this.user.sensingtexHardwareSerial, this.user.sensingtexManagerId).subscribe()
      Swal.fire({
        title: this.translate.instant('OD_DOING_ANALYSIS'),
        html: this.translate.instant('OD_FOLLOW_STEPS_20_SEC'),
        timer: dynamicTimerSeconds * 1000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          this.loadPatients()
        }
      })
    }

    if (analysisType === "balance") {
      this.balanceModalVisible = false

      this.sensingtexService.requestAnalysis(this.selectedPatient, analysisType, this.user.sensingtexHardwareSerial, this.user.sensingtexManagerId).subscribe()
      Swal.fire({
        title: this.translate.instant('OD_DOING_ANALYSIS'),
        html: this.translate.instant('OD_STAND_15_SEC'),
        timer: balanceTimerSeconds * 1000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          this.loadPatients()
        }
      })
    }
  }

  goToAnalysisDetails(orderId: string, analysisId: string): void {
    this.router.navigate(['/analysis-details', orderId, analysisId]);
  }

  deleteAnalysis(analysisId: string) {
    Swal.fire({
      title: this.translate.instant('OD_DELETE_ANALYSIS_CONFIRM'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('OD_YES_DELETE'),
      cancelButtonText: this.translate.instant('OD_NO_BACK')
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: this.translate.instant('OD_REMOVING_ANALYSIS')
        })
        Swal.showLoading()
        setTimeout(() => {
          this.sensingtexService.deleteAnalysis(analysisId).subscribe(
            (resp) => {
              this.loadPatients();
              Swal.fire(this.translate.instant('OD_ANALYSIS_DELETED'), '', 'success');
            },
            (err) => {
              Swal.fire('Error', err.error.message, 'error');
            }
          );
        }, 2000);

      }
    });
  }

  onPDFGenerationComplete() {
    this.PDFDetailsVisible = false;
  }

  getRecordById() {
    this.orderRecordSubscription = this.orderService.getRecord(this.orderId).subscribe((scan) => {
      this.orderRecord = scan;
      console.log("this.orderrecord: ", this.orderRecord)
    });
  }

  getFormResponseById() {
    this.insolesPrescriptionForm = null

    this.formResponseService.getOneByFormId(this.order.formResponseId).subscribe((res: FormResponse) => {

      const questions = res?.questions ?? [];

      // --- Aquí solo manejamos los flags ---
      const hasInsolesPrescription = questions.some(q => q.type === 'insolesPrescription');
      const hasOtherTypes = questions.some(q => q.type !== 'insolesPrescription');
      const hasCustomComponents = questions.some(q => q.type === "customComponents")

      if (hasCustomComponents) {
        this.hasCustomComponents = true
      }

      if (hasInsolesPrescription) {
        this.hasInsolesPrescription = true;
        this.hasOrderForm = false;
      } else if (hasOtherTypes) {
        this.hasInsolesPrescription = false;
        this.hasOrderForm = true;
      } else {
        this.hasInsolesPrescription = false;
        this.hasOrderForm = false;
      }

      questions.map((question) => {
        if (question.type === 'insolesPrescription') {

          let insoleComponentsConfig = insoleComponentesConfig;
          let insoleComponentsForms = [];

          // Add all the components to the components prescription form
          insoleComponentsConfig.map((component) => {
            insoleComponentsForms.push(component.form)
          })

          // Create Insoles Prescription Form
          this.insolesPrescriptionForm = this.formBuilder.group({
            type: new FormControl('insolesPrescription', { nonNullable: true }),
            shellType: new FormControl('thin', { nonNullable: true }),
            lengthType: new FormControl('3-4', { nonNullable: true }),
            thinThickness: new FormControl(2, { nonNullable: true }),
            components: this.formBuilder.array(insoleComponentsForms)
          })

          question = question as InsolesPrescriptionResponse;
          this.insolesPrescriptionForm.patchValue({
            shellType: question.shellType || 'thin',
            lengthType: question.lengthType || '3-4',
            thinThickness: question.thinThickness || 2
          });
          question.components.map((insoleComponent) => {

            let componentConfig = insoleComponentsConfig.find((insoleComponentConfig) => insoleComponentConfig.form.get('type').value === insoleComponent.type);

            if (insoleComponent.left) {
              if (insoleComponent.left.value) {
                // Check if the value exists on the list, if not, then select 'others' options and apply the values
                if (componentConfig.selectOptions) {
                  let foundSelecOption = componentConfig.selectOptions.find((selectOption) => selectOption.value === insoleComponent.left.value)

                  if (foundSelecOption) {
                    insoleComponent.left.selectedName = insoleComponent.left.value;
                  } else {
                    insoleComponent.left.selectedName = "others";
                    insoleComponent.left.value = insoleComponent.left.value;
                  }
                }
              }

              // If contains medial and not lateral that means it has to have "position"
              if ('medial' in insoleComponent.left && !('lateral' in insoleComponent.left)) {
                insoleComponent.left.position = 'medial'
              }
              if ('lateral' in insoleComponent.left && !('medial' in insoleComponent.left)) {
                insoleComponent.left.position = 'lateral'
              }

              // Flanges check
              insoleComponent = new InsolesPrescriptionMapper().rawFlangesDataToForm(['left'], insoleComponent, componentConfig);
            }

            if (insoleComponent.right) {
              if (insoleComponent.right.value) {
                // Check if the value exists on the list, if not, then select 'others' options and apply the values
                if (componentConfig.selectOptions) {
                  let foundSelecOption = componentConfig.selectOptions.find((selectOption) => selectOption.value === insoleComponent.right.value)

                  if (foundSelecOption) {
                    insoleComponent.right.selectedName = insoleComponent.right.value;
                  } else {
                    insoleComponent.right.selectedName = "others";
                    insoleComponent.right.value = insoleComponent.right.value;
                  }
                }
              }

              // If contains medial and not lateral that means it has to have "position"
              if ('medial' in insoleComponent.right && !('lateral' in insoleComponent.right)) {
                insoleComponent.right.position = 'medial'
              }
              if ('lateral' in insoleComponent.right && !('medial' in insoleComponent.right)) {
                insoleComponent.right.position = 'lateral'
              }

              // Flanges check
              insoleComponent = new InsolesPrescriptionMapper().rawFlangesDataToForm(['right'], insoleComponent, componentConfig);
            }

            const componentsArray = this.insolesPrescriptionForm.get('components') as FormArray;
            // Encuentra los grupos de formulario específicos
            const foundComponent = componentsArray.controls
              .find(fg => fg.get('type').value === insoleComponent.type) as FormGroup;

            foundComponent.patchValue(insoleComponent);

          })

          this.hasInsolesPrescription = true;
        }
      })

      this.formResponse = res
    })
  }

  updateInsolesPrescription() {
    this.isLoading = true
    Swal.showLoading();

    const rawValues = this.insolesPrescriptionForm.getRawValue();
    const components = rawValues.components;
    const shellType = rawValues.shellType;
    const lengthType = rawValues.lengthType;
    const thinThickness = rawValues.thinThickness

    // Filtrar componentes donde footSelection no es nulo
    const filteredComponents = components
      .filter(component => component.footSelection !== null && component.footSelection !== undefined)
      .map(component => {
        // Si footSelection es 'right', eliminar 'left'
        if (component.footSelection === 'right') {
          delete component.left;
        }

        // Si footSelection es 'left', eliminar 'right'
        if (component.footSelection === 'left') {
          delete component.right;
        }

        // Función para manejar la eliminación de 'medial' y 'lateral'
        const manageMedialLateral = (side) => {
          if (side) { // Verifica si el lado está definido
            if (side.position === 'lateral') {
              delete side.medial; // Eliminar medial si lateral está presente
            } else if (side.position === 'medial') {
              delete side.lateral; // Eliminar lateral si medial está presente
            }
          }
        };

        // Manejar medial y lateral para ambos lados
        manageMedialLateral(component.left);
        manageMedialLateral(component.right);

        return component;
      });

    // Crear la pregunta actualizada de prescription
    const updatedPrescriptionQuestion = {
      title: "Insole prescription",
      type: "insolesPrescription",
      shellType: shellType,
      lengthType: lengthType,
      thinThickness: thinThickness,
      components: filteredComponents
    };

    // Copiar todas las preguntas existentes y actualizar solo la de prescription
    const updatedQuestions = this.formResponse.questions.map(q => {
      if (q.type === 'insolesPrescription') {
        return updatedPrescriptionQuestion;
      }
      return q;
    });

    const payload = {
      ID: this.order.formResponseId,
      orderId: this.orderId,
      formTitle: this.formResponse.formTitle,
      formId: this.formResponse.formId,
      createdAt: this.formResponse.createdAt,
      updatedAt: new Date().toISOString(), // Usar fecha actual para updatedAt
      questions: updatedQuestions, // Usar todas las preguntas, no solo prescription
      requireScans: this.formResponse.requireScans,
      requireWeb3DScans: this.formResponse.requireWeb3DScans
    }

    this.formResponseService.updateFormResponse(payload).subscribe({
      next: async () => {
        try {
          await this.regenerateAndUploadPdf(payload);

          Swal.close()
          Swal.fire(this.translate.instant('OD_INSOLES_UPDATED'), '', 'success');
        } catch (error) {
          console.error("Error regenerating PDF: ", error);
          Swal.close()
          Swal.fire(
            this.translate.instant('OD_INSOLES_UPDATED'),
            this.translate.instant('OD_PDF_UPDATE_WARNING'),
            'warning'
          );
        }

      },
      error: (err) => {
        console.error("Error updating insoles prescription: ", err.error.message)
        Swal.close()
        Swal.fire(`Error: ${err.error.message}`, '', 'error');
      }
    })

    this.isLoading = false
  }

  private async regenerateAndUploadPdf(updatedFormResponse: any): Promise<void> {
    try {
      // Crear una copia del order con el formResponse actualizado
      const updatedOrder = {
        ...this.order,
        formResponses: [updatedFormResponse]
      };

      // Mapear los datos al formato del PDF
      const pdfData = OrderPdfMapper.mapScanToOrderPdf(updatedOrder, [updatedFormResponse]);

      // Generar el PDF
      const pdfBlob = await this.orderPdfGenerator.generateOrderPdf(pdfData);

      // Crear el nombre del archivo
      const patientName = pdfData.patientData.name?.replace(/[^a-zA-Z0-9]/g, '') || '';
      const patientSurname = pdfData.patientData.surname?.replace(/[^a-zA-Z0-9]/g, '') || '';
      const filename = `${patientName}_${patientSurname}_${pdfData.orderId}.pdf`;

      // Convertir blob a File
      const pdfFile = new File([pdfBlob], filename, { type: 'application/pdf' });

      // Subir el archivo (esto reemplazará el PDF anterior en S3)
      await this.uploadFile(pdfFile);
    } catch (error) {
      console.error('❌ Error regenerating PDF:', error);
      throw error;
    }
  }

  getRowIndex(row: any, questions: any[]): number {
    return questions.indexOf(row) + 1;
  }

  formatCreationDate(rawDate: string): string {
    const date = new Date(rawDate);

    const month = date.toLocaleString('en-US', { month: 'short' });
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    const formattedDate = `${month} ${day} ${year} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
  }

  displayCustomComponentsResponse(components: any[]): string {
    return components.map(component => {
      const title = `Title: ${component.title}`;
      const image = component.image ? `Image: <img src="${component.image}" alt="${component.title}">` : '';
      const choices = this.formatChoices(component.choices);

      if (choices) {
        return `<div>
                  <p>${title}</p>
                  ${image}
                  <p>Choices:</p>
                  <ul>${choices}</ul>
                </div>`;
      } else {
        return ''; // Skip if no choices
      }
    }).join('\n');
  }

  formatChoices(choices: any): string {
    return Object.keys(choices).map(choiceType => {
      const choiceData = choices[choiceType];

      if (Array.isArray(choiceData) && choiceData.length > 0) {
        const formattedChoices = choiceData.map(choice => {
          return `${this.formatChoiceRecursive(choice)}`;
        }).join('\n');

        return `<li>${choiceType}:
                  <ul>${formattedChoices}</ul>
                </li>`;
      } else if (typeof choiceData === 'object' && Object.keys(choiceData).length > 0) {
        return `<li>${choiceType}:
                  <ul>${this.formatChoiceRecursive(choiceData)}</ul>
                </li>`;
      } else {
        return ''; // Skip if empty array or object
      }
    }).join('\n');
  }

  formatChoiceRecursive(choice: any): string {
    const formattedChoices = [];

    for (const key in choice) {
      if (choice.hasOwnProperty(key)) {
        const value = choice[key];
        let formattedValue;

        if (key === 'responses' && typeof value === 'object') {
          // Convert responses object to a comma-separated string
          formattedValue = Object.values(value).join(',');
        } else {
          formattedValue = typeof value === 'object' ? `{${this.formatChoiceRecursive(value)}}` : value;
        }

        formattedChoices.push(`<li>${key}: ${formattedValue}</li>`);
      }
    }

    return formattedChoices.join('\n');
  }


  displayResponseByType(row: any): string {
    const { type, responses, components, response, image } = row;

    switch (type) {
      case 'inputText':
      case 'longText':
      case 'dropdown':
        return response;
      case 'multipleChoice':
        return this.displayMultipleChoiceResponse(responses);
      case 'customComponents':
        return this.displayCustomComponentsResponse(components);
      case 'productsList':
        return this.displayProductsListResponse(response, image);
      default:
        return ''; // Handle other types as needed
    }
  }

  displayMultipleChoiceResponse(responses: any): string {
    if (Array.isArray(responses)) {
      return responses.map(response => {
        return `<p>Title:${response.title}</p>\nImage: <img src=${response.image}>\n <p>Responses: ${response.responses}</p>`;
      }).join('\n');
    }
    return '';
  }

  displayProductsListResponse(response: string, image: string): string {
    return `<img src="${response}" alt="Product Image">`;
  }

  backToOrderList() {
    this.router.navigate(['/home'])
  }

  showTab(tab: string): void {
    this.isLoading = true
    this.showGeneralTab = tab === 'general';
    this.showPressurePlateTab = tab === 'pressurePlate';
    this.showPrescriptionTab = tab === 'prescription';
    this.showChargesTab = tab === 'charges';
    this.showFilesTab = tab === 'files'
    this.isLoading = false

    if (this.showFilesTab && this.order.pdfFilesAccount > 0) {
      const PDFfiles = this.order.files.filter(file => file.type === 'pdf');
      console.log("PDFFILES: ", PDFfiles)

      setTimeout(() => {
        PDFfiles.map(file => {
          this.initAdobePDFViewer(file);
        });
      }, 50);
    }
  }

  async initAdobePDFViewer(file: any) {
    if (!window.AdobeDC) {
      console.error("Adobe View SDK not loaded.");
      return;
    }

    const adobeDCView = new AdobeDC.View({
      clientId: environment.adobeClientId,
      divId: `adobe-dc-view-${file.name}`
    });

    adobeDCView.previewFile(
      {
        content: { location: { url: `${file.path}?nocache=${Date.now()}` } },
        metaData: { fileName: file.name, hasReaderOnlyAccess: false, enableFormFilling: true }
      },
      {
        embedMode: "FULL_WINDOW",
        enableFormFilling: true,
        showAnnotationTools: true
      }
    );

    adobeDCView.registerCallback(
      AdobeDC.View.Enum.CallbackType.SAVE_API,
      async (metaData, content) => {
        try {
          console.log("💾 SAVE_API trigger, preparando PDF con formularios...");

          // Subir el PDF al assetId
          const blob = new Blob([content], { type: "application/pdf" });
          const tempFile = new File([blob], metaData.fileName || 'pdf-editado.pdf', { type: 'application/pdf' });

          this.uploadFile(tempFile)

          return {
            code: AdobeDC.View.Enum.ApiResponseCode.SUCCESS,
            data: { metaData: Object.assign(metaData, { updatedAt: new Date().toISOString() }) }
          };

        } catch (err) {
          console.error("❌ Error procesando PDF con formularios", err);
          return { code: AdobeDC.View.Enum.ApiResponseCode.FAIL };
        }
      },
      { autoSaveFrequency: 0 }
    );
  }

  createZipFile(file: File): Promise<Blob> {
    return new Promise<Blob>((resolve, reject) => {
      const zip = new JSZip();

      zip.file(file.name, file)

      // Generar el archivo zip y resolver la promesa
      zip.generateAsync({ type: 'blob' })
        .then((blob) => resolve(blob))
        .catch((err) => reject(err));
    });
  }

  async uploadFile(file: File) {

    const signedZipUrlResponse = await lastValueFrom(this.scanService.getSignedZipUrl(this.orderId));
    const signedZipUrl = signedZipUrlResponse.signedZipUrl;

    if (!signedZipUrl) {
      Swal.fire('Error', 'No signed URL available for upload', 'error');
      return;
    }

    this.scanService.getOne(this.orderId).subscribe({
      next: (res: any) => {
        this.selectedOrder = res

        this.createZipFile(file).then((blob) => {
          Swal.update({
            title: "Uploading files",
            showConfirmButton: false
          })
          Swal.showLoading();
          this.scanService.uploadZipFile(signedZipUrl, blob).subscribe({
            next: (res) => {
              console.log('✅ Upload OK, status:', res.status);
              Swal.fire('Success', 'Files uploaded successfully', 'success');
              this.selectedOrder = null;
            },
            error: (err) => {
              console.error('❌ Upload error:', err);
              Swal.fire('Error', `Error uploading files: ${err.message}. Please try again`, 'error');
              this.selectedOrder = null;
            }
          });
        });
      },
      error: (err) => {
        Swal.fire('Error', `Error fetching order: ${err.message}`, 'error');
      }
    })
  }

  getKeyValuePairs(obj: any): { key: string, value: any }[] {
    if (obj && typeof obj === 'object') {
      return Object.entries(obj).map(([key, value]) => ({ key, value }));
    }
    return [];
  }

  isEmpty(value: any): boolean {
    // Consideramos vacío si es null, undefined, string vacío o un objeto sin claves
    if (value === null || value === undefined) return true;
    if (typeof value === 'string' && value.trim() === '') return true;
    if (typeof value === 'object') return Object.keys(value).length === 0;
    return false;
  }

  formatValue(value: any): string {
    if (typeof value === 'object' && value !== null) {
      return value.name ?? JSON.stringify(value);
    }
    return value;
  }

  openUpdatePatientDataModal(key: string, value: any) {
    if (key == 'Files' || key == 'Device Info') return

    this.currentKey = key;

    const filteredFields = Object.entries(value)
      .filter(([_, val]) => !this.isEmpty(val))
      .map(([key, val]) => {
        // Si es clinic, pasar solo el nombre
        if (key === 'clinic' && val && typeof val === 'object' && 'name' in val) {
          return { key, value: (val as { name: string }).name };
        }
        return { key, value: val };
      });

    this.editableFields = filteredFields;

    // Crear el form con solo esos campos
    const formGroup: { [key: string]: FormControl } = {};
    this.editableFields.forEach(field => {
      formGroup[field.key] = new FormControl(field.value);


      // Si la key es "clinic", deshabilitar el campo
      if (field.key === 'clinic') {
        formGroup[field.key].disable();
      }
    });
    this.editForm = new FormGroup(formGroup);
    this.showEditPatientDataModal = true;
  }

  async savePatientData() {
    this.isLoading = true;
    if (this.editForm?.invalid) return;

    const updatedSection = this.editForm.value;

    // Clonar todos los datos actuales del scan
    const fullData = {
      ...this.order.data,
      [this.currentKey]: updatedSection, // actualizar solo la sección que el usuario editó
    };

    console.log("Full data to update: ", fullData);

    try {
      await lastValueFrom(
        this.scanService.updatePatientData(this.orderId, fullData)
      );

      // Actualizar los datos locales con la versión completa
      this.order.data = { ...fullData };

      this.showEditPatientDataModal = false;

      Swal.fire({
        icon: 'success',
        title: 'Data updated successfully',
        showConfirmButton: false,
        timer: 1500,
      });

    } catch (error) {
      console.error("Error updating patient data:", error);
      Swal.fire({
        icon: 'error',
        title: 'Update failed',
        text: 'There was an error while updating the data. Please try again.',
      });
    }
    this.isLoading = false;
  }

  get questionsWithComponents() {
    return this.formResponse?.questions?.filter((q: any) => q.components?.length > 0) || [];
  }

  downloadFormResponsePDF() {
    // Buscar específicamente la card que contiene "Form Response"
    const allCards = document.querySelectorAll('mat-card.cardWithShadow.theme-card');
    let formResponseCard: HTMLElement | null = null;

    allCards.forEach(card => {
      const titleElement = card.querySelector('mat-card-title');
      if (titleElement && titleElement.textContent?.trim() === 'Form Response') {
        formResponseCard = card as HTMLElement;
      }
    });

    if (!formResponseCard) {
      console.error('Form response card not found');
      return;
    }

    // Crear el PDF con jsPDF
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    let currentY = 20;

    // Información del paciente y clínica en dos columnas
    const leftColumnX = 20;
    const rightColumnX = pageWidth / 2 + 10;
    let leftColumnY = currentY;
    let rightColumnY = currentY;

    // Columna izquierda - Información del paciente
    pdf.setFontSize(8);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Patient Information:', leftColumnX, leftColumnY);
    leftColumnY += 8;

    pdf.setFont('helvetica', 'normal');
    const patientName = this.order?.data?.['Patient Data']?.name ?? null;
    const patientSurname = this.order?.data?.['Patient Data']?.surname || '';
    const patientBirthDate = this.order?.data?.['Patient Data']?.birthDate || 'N/A';
    const patientGender = this.order?.data?.['Patient Data']?.sex ?? null;

    if (patientName) {
      pdf.text(`Name: ${patientName} ${patientSurname}`, leftColumnX + 5, leftColumnY);
      leftColumnY += 6;
    }

    if (patientGender) {
      pdf.text(`Gender: ${patientGender}`, leftColumnX + 5, leftColumnY);
      leftColumnY += 6;
    }

    if (patientBirthDate) {
      pdf.text(`Birth date: ${patientBirthDate}`, leftColumnX + 5, leftColumnY);
      leftColumnY += 2;
    }

    // Columna derecha - Información del cliente/clínica
    pdf.setFont('helvetica', 'bold');
    pdf.text('Clinic Information:', rightColumnX, rightColumnY);
    rightColumnY += 8;

    pdf.setFont('helvetica', 'normal');
    const clinicName = this.order?.data?.['Patient Data']?.clinic?.name?.toString() || 'N/A';

    if (clinicName) {
      pdf.text(`Clinic: ${clinicName}`, rightColumnX + 5, rightColumnY);
      rightColumnY += 6;
    }

    if (this.clientName) {
      pdf.text(`Client: ${this.clientName}`, rightColumnX + 5, rightColumnY);
      rightColumnY += 6;
    }


    // Usar la mayor altura de las dos columnas para continuar
    currentY = Math.max(leftColumnY, rightColumnY) + 10;

    // Título Order Form
    pdf.setFont('helvetica', 'bold');
    pdf.text('Order Form', 20, currentY);
    currentY += 5;

    // Ocultar temporalmente el botón PDF
    const pdfButton = formResponseCard.querySelector('button[mat-raised-button]') as HTMLElement;
    const originalDisplay = pdfButton ? pdfButton.style.display : '';
    if (pdfButton) {
      pdfButton.style.display = 'none';
    }

    // Ocultar temporalmente el header de la card
    const formResponseTitle = formResponseCard.querySelector('mat-card-header.removable-header') as HTMLElement;
    const originalDisplayFormResponseTitle = formResponseTitle ? formResponseTitle.style.display : '';
    if (formResponseTitle) {
      formResponseTitle.style.display = 'none';
    }


    // Aplicar estilos temporales para mejorar la visualización en PDF
    const responseCards = formResponseCard.querySelectorAll('.response-card');
    const originalResponseStyles: { element: HTMLElement, styles: any }[] = [];

    responseCards.forEach(card => {
      const cardElement = card as HTMLElement;
      const originalStyles = {
        border: cardElement.style.border,
        borderRadius: cardElement.style.borderRadius,
        backgroundColor: cardElement.style.backgroundColor,
        boxShadow: cardElement.style.boxShadow,
        marginBottom: cardElement.style.marginBottom
      };
      originalResponseStyles.push({ element: cardElement, styles: originalStyles });

      cardElement.style.border = '2px solid #e0e0e0';
      cardElement.style.borderRadius = '10px';
      cardElement.style.backgroundColor = '#ffffff';
      cardElement.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
      cardElement.style.marginBottom = '15px';
    });

    const componentCards = formResponseCard.querySelectorAll('.component-card');
    const originalComponentStyles: { element: HTMLElement, styles: any }[] = [];

    componentCards.forEach(card => {
      const cardElement = card as HTMLElement;
      const originalStyles = {
        border: cardElement.style.border,
        borderRadius: cardElement.style.borderRadius,
        backgroundColor: cardElement.style.backgroundColor,
        boxShadow: cardElement.style.boxShadow,
        marginBottom: cardElement.style.marginBottom
      };
      originalComponentStyles.push({ element: cardElement, styles: originalStyles });

      cardElement.style.border = '2px solid #d0d0d0';
      cardElement.style.borderRadius = '8px';
      cardElement.style.backgroundColor = '#ffffff';
      cardElement.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
      cardElement.style.marginBottom = '15px';
    });

    // Generar imagen del contenido del form response
    html2canvas(formResponseCard, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
      height: formResponseCard.scrollHeight,
      width: formResponseCard.scrollWidth
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');

      const imgWidth = 170;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const remainingHeight = pageHeight - currentY - 10;

      if (imgHeight <= remainingHeight) {
        // La imagen cabe en la página actual
        pdf.addImage(imgData, 'PNG', 20, currentY, imgWidth, imgHeight);
      } else {
        // La imagen necesita múltiples páginas
        let heightLeft = imgHeight;
        let position = currentY;
        let isFirstPage = true;

        while (heightLeft > 0) {
          if (!isFirstPage) {
            pdf.addPage();
            position = 20;
          }

          const availableHeight = isFirstPage ? remainingHeight : pageHeight - 40;
          const sectionHeight = Math.min(heightLeft, availableHeight);
          const sourceY = imgHeight - heightLeft;

          // Crear un canvas temporal para la sección
          const tempCanvas = document.createElement('canvas');
          const tempCtx = tempCanvas.getContext('2d');
          tempCanvas.width = canvas.width;
          tempCanvas.height = (sectionHeight * canvas.width) / imgWidth;

          tempCtx.drawImage(canvas, 0, (sourceY * canvas.width) / imgWidth, canvas.width, tempCanvas.height, 0, 0, canvas.width, tempCanvas.height);

          const sectionImgData = tempCanvas.toDataURL('image/png');
          pdf.addImage(sectionImgData, 'PNG', 20, position, imgWidth, sectionHeight);

          heightLeft -= sectionHeight;
          isFirstPage = false;
        }
      }

      const fileName = `${patientName}-${patientSurname}-${new Date().toISOString().split('T')[0]}.pdf`;
      pdf.save(fileName);

      // Restaurar estilos originales
      originalResponseStyles.forEach(({ element, styles }) => {
        Object.keys(styles).forEach(key => {
          element.style[key] = styles[key];
        });
      });

      originalComponentStyles.forEach(({ element, styles }) => {
        Object.keys(styles).forEach(key => {
          element.style[key] = styles[key];
        });
      });

      // Restaurar el botón PDF
      if (pdfButton) {
        pdfButton.style.display = originalDisplay;
      }

      // Restaurar título Form Response
      if (formResponseTitle) {
        formResponseTitle.style.display = originalDisplayFormResponseTitle
      }

    }).catch(error => {
      console.error('Error generating PDF:', error);

      // Restaurar estilos en caso de error
      originalResponseStyles.forEach(({ element, styles }) => {
        Object.keys(styles).forEach(key => {
          element.style[key] = styles[key];
        });
      });

      originalComponentStyles.forEach(({ element, styles }) => {
        Object.keys(styles).forEach(key => {
          element.style[key] = styles[key];
        });
      });

      if (pdfButton) {
        pdfButton.style.display = originalDisplay;
      }
    });
  }

  openImageDialog(file: any): void {
    this.dialog.open(this.imageDialog, {
      data: file,
      width: '70%',
      height: '90%'
    });
  }

  openStaticModal() {
    this.staticModalVisible = true
  }

  openDynamicModal() {
    this.dynamicModalVisible = true
  }

  openBalanceModal() {
    this.balanceModalVisible = true
  }

  showPDFDetails() {
    this.PDFDetailsVisible = true
  }

  openUpgradeModal() {
    this.upgradeModalVisible = true
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  /**
   * Traduce las claves dinámicas de order.data
   * @param key - Clave original en inglés
   * @returns Clave traducida
   */
  translateOrderDataKey(key: string): string {
    const translationKey = `ORDER_DATA_KEYS.${key}`;
    const translated = this.translate.instant(translationKey);

    // Si la traducción no existe, devolver la clave original
    return translated !== translationKey ? translated : key;
  }

  /**
   * Traduce los campos anidados de order.data
   * @param field - Campo original en inglés
   * @returns Campo traducido
   */
  translateOrderDataField(field: string): string {
    const translationKey = `ORDER_DATA_FIELDS.${field}`;
    const translated = this.translate.instant(translationKey);

    // Si la traducción no existe, devolver el campo original
    return translated !== translationKey ? translated : field;
  }

  /**
   * Obtiene el placeholder traducido para un campo
   * @param field - Campo original en inglés
   * @returns Placeholder traducido
   */
  getFieldPlaceholder(field: string): string {
    const translatedField = this.translateOrderDataField(field);
    const enterText = this.translate.instant('OD_ENTER');
    return `${enterText} ${translatedField}`;
  }
}
